import React from "react";
import logo from "../static/logo.png";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { useTranslation } from "../i18n";

// 创建 memoized selector
const selectUrls = createSelector(
  (state: RootState) => state.apkUrl,
  (state: RootState) => state.exeUrl,
  (state: RootState) => state.ipaUrl,
  // 只有当 apkUrl 或 exeUrl 变化时才会重新计算
  (apkUrl, exeUrl, ipaUrl) => ({ apkUrl, exeUrl, ipaUrl }),
);

const Header: React.FC = () => {
  // function isMobile() {
  //   const mobileReg =
  //     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  //   return mobileReg.test(navigator.userAgent);
  // }
  function getDeviceType() {
    const userAgent = navigator.userAgent;

    if (/Android/i.test(userAgent)) {
      return "Android";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "iOS";
    } else if (/Windows/i.test(userAgent)) {
      return "Windows";
    } else {
      return "Unknown";
    }
  }

  // 使用 memoized selector
  const { apkUrl, exeUrl, ipaUrl } = useSelector(selectUrls);
  const { t } = useTranslation();

  return (
    <div className="w-full h-16 px-siderPad justify-between   flex items-center bg-[rgba(255,255,255,0.9)] backdrop-blur-[4px] text-[16px] fixed top-0 z-[10]">
      <div className="flex items-center gap-5">
        <div className="flex items-center gap-2">
          <img src={logo} alt="" className="w-[32px] h-[32px] " />
          <p className="text-[#333333FF] text-[20px]">DeepSurf</p>
        </div>
        <div className="w-[1px] h-[26px] bg-[#00000008]"></div>
        <p className="text-[#666666FF]">{t("slogan")}</p>
      </div>
      <p
        className=" bg-[#4F6BFEFF] w-[146px] h-[32px] leading-[32px] text-center text-[#FFFFFFFF] text-[14px] rounded-full cursor-pointer hover:bg-[#4c67ee]"
        onClick={() => {
          // window.open(isMobile() ? apkUrl : exeUrl);
          window.open(
            getDeviceType() === "Android"
              ? apkUrl
              : getDeviceType() === "iOS"
                ? ipaUrl
                : exeUrl,
          );
        }}
      >
        {t("startUsing")}
      </p>
    </div>
  );
};
export default Header;
